// extracted by mini-css-extract-plugin
export var infoRow = "_nu-2";
export var labelContainer = "_nu-0";
export var rightInfo = "_nu-1";